// extracted by mini-css-extract-plugin
module.exports = {"ra-container":"ra-container_ra-container__xgjzL","ra-container--max-width":"ra-container_ra-container--max-width__CbtFx"};